import { q, qq, ww } from 'bobjoll/ts/library/dom';
import { cookie } from 'Library/cookie';
import { EventTracker } from 'Library/eventTacker';

import { crusadeCallback } from './crusades';

/**
 * Crusades
 */
crusadeCallback();

/**
 * Billing Info
 */
if (UPDATE_BILLING_INFO) {
    let updateBillingInfoElement = document.getElementById('update-billing-info');
    let closeButton = updateBillingInfoElement?.querySelector('.close');
    if (closeButton) {
        closeButton.addEventListener('click', () => {
            updateBillingInfoElement?.remove();
            document.body.classList.remove('topbar-active');
            const expiredCookie = new Date().getTime() + 7 * 24 * 60 * 60 * 1000; // 7 days
            cookie.setItem('update-billing-info', '1', {
                expires: new Date(expiredCookie),
            });
        });
    }
}
